export default __webpack_public_path__ + "static/media/37t.59b679a9.jpg";